import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { HttpClient, HttpContext } from "@angular/common/http"
import { Observable } from "rxjs";
import { OnboardingTenantConfigDto, OnboardingExecuteRequest } from "../models/automaticOnboarding/onboarding-automatic-request"
import { ObservabilityService } from "src/app/core/observability/observability.service"
import { OTEL_PARENT_CONTEXT } from "src/app/core/observability/observability-context"
import { tap } from "rxjs/operators"

@Injectable()
export class OnboardingService {
  private get_config_onboarding: string
  private post_config_onboarding: string
  private put_config_onboarding: string
  private post_execute_onboarding: string

  private buildUrls(onboardingUrl: string) {
    this.get_config_onboarding = onboardingUrl + environment.endpointOnboarding.routes.get_config
    this.post_config_onboarding = onboardingUrl + environment.endpointOnboarding.routes.post_config
    this.put_config_onboarding = onboardingUrl + environment.endpointOnboarding.routes.put_config
    this.post_execute_onboarding = onboardingUrl + environment.endpointOnboarding.routes.post_execute
  }

  constructor(private httpClient: HttpClient, private observability: ObservabilityService) {
    this.buildUrls(environment.endpointOnboarding.url)
  }

  getTenantConfig(tenantId: string): Observable<OnboardingTenantConfigDto> {
    return this.httpClient.get<OnboardingTenantConfigDto>(
      this.get_config_onboarding.replace("{tenantId}", tenantId)
    )
  }

  postTenantConfig(model: OnboardingTenantConfigDto) {
    return this.httpClient.post(this.post_config_onboarding, model)
  }

  putTenantConfig(model: OnboardingTenantConfigDto) {
    return this.httpClient.put( this.put_config_onboarding, model)
  }

  postExecuteOnboarding(model: OnboardingExecuteRequest) {
    const operation = this.observability.startOperation("onboarding.execute")
    return this.httpClient.post(this.post_execute_onboarding, model, {
      context: new HttpContext().set(OTEL_PARENT_CONTEXT, operation.otelContext),
    }).pipe(tap({
      next: () => operation.succeed(),
      error: (error) => operation.fail(error),
    }))
  }

}
